import Head from 'next/head';
import Image from 'next/image';
import styles from '../../styles/sass/pages/About.module.scss'
import useWindowSize from '../../util/useWindowSize'

import aboutWithQuote from '../../../public/img/about-with-quote.png';
import aboutWithoutQuote from '../../../public/img/about-without-quote.jpeg';

export default function AboutMe() {
    const size = useWindowSize();

    return (
        <>
            <Head>
                <title>Rólam | Szabó Jennifer Pszichológus</title>
                <meta name="description" content="Szabó Jennifer, tanácsadó szakpszichológus, irodalomterapeuta, kognitív viselkedésterápiás konzultáns" />
                <meta property="og:title" content="Rólam | Szabó Jennifer Pszichológus" />
                <meta property="og:type" content="article" />
                <meta property="og:description" content="Szabó Jennifer, tanácsadó szakpszichológus, irodalomterapeuta, kognitív viselkedésterápiás konzultáns" />
                <meta property="og:url" content="https://szabojennifer.hu/rolam" />
                <meta property="og:image" content="/img/about-without-quote.jpeg" />
                <meta property="og:image:alt" content="Szabó Jennifer portré" />
            </Head>
            <div className={styles.hero}>
                {size.width > 1344 ?
                    <div className={styles.heroImgBox}>
                        <Image
                            src={aboutWithQuote}
                            className={styles.heroImg}
                            priority
                            alt="Szabó Jennifer pszichológus"
                            placeholder='blur'
                            quality={100}
                            fill
                            sizes='100vw'
                            style={{
                                objectFit: 'cover',
                                objectPosition: '60% 30%'
                            }}
                        />
                    </div>
                    :
                    <div className={styles.heroImgBox}>
                        <Image
                            src={aboutWithoutQuote}
                            className={styles.heroImg}
                            fill
                            sizes='100vw'
                            style={{
                                objectFit: 'cover',
                                objectPosition: '60% 30%'
                            }}
                            priority
                            alt="Szabó Jennifer pszichológus"
                        />
                    </div>
                }

            </div>
            <div className={styles.aboutContainer}>
                <div className={styles.aboutDescriptionContainer}>
                    {size.width < 1344 &&
                        <div className={styles.mobileQuoteContainer}>
                            <Image
                                src="/img/quote-2.png"
                                width={1000}
                                height={600}
                                objectPosition='60% 30%'
                                alt="Szabó Jennifer pszichológus és egy Szerb Antal idézet"
                            />

                        </div>}
                    <div className={styles.aboutDescription}>
                        <h1 className={` ${styles.headingSecondary}  mt-12 text-4xl mb-8`}> Szabó Jennifer vagyok, </h1>
                        <div className={` ${styles.aboutDescriptionLead}`}>tanácsadó szakpszichológus, irodalomterapeuta, kognitív viselkedésterápiás konzultáns.</div>
                        <div className={styles.aboutDescriptionText}>
                            <p>Integratív szemléletben dolgozom, amiben az aktív-analitikus, személyközpontú, trauma-informált szemlélet is megjelenik, rugalmasan alkalmazkodva klienseim egyéni igényeihez. A közös munka során arra törekszem, hogy a hozzám forduló felnőttek képessé váljanak önmagukkal egy önazonosabb kapcsolatot kialakítani, nehézségeiket, mintáikat mélyebben megérteni, ezáltal kiegyensúlyozottabban kapcsolódni környezetükhöz is.                                
                            </p>
                            <br />
                            <p>Fontos számomra, hogy a hozzám fordulók olyan elfogadó légkört tapasztalhassanak meg, ahol közelebb kerülhetnek az érzéseikhez és kimondhatóvá válhatnak a nehéz történetek is. Hiszem, hogy a változáshoz szükséges erőforrások mindannyiunkban jelen vannak, és egy biztonságos kapcsolat segíthet ezek felismerésében és mozgósításában. Célom, hogy klienseim fokozatosan otthonosabban érezzék magukat önmagukban, és nagyobb belső szabadsággal tudjanak jelen lenni az életükben.
                            </p>
                            <br />
                            <p>A közös munka hosszú távú értéke lehet egy olyan önreflexiós szemlélet felépítése, amely a folyamat lezárása után is erőforrásként tudja kísérnie a klienseimet. Hiszen az önismeret nem egy végállomás,  hanem egy szemléletmód, ami az életünk során segít minket tudatosabban kapcsolódni önmagunkhoz, másokhoz és az élet kihívásaihoz.
                            </p>
                            <br />
                            <p>Saját önismereti munkámat többféle csoportterápiás és egyéni pszichoterápiás folyamatban végeztem és végzem. Szakmai munkámat rendszeres szupervízió támogatja és segíti.
                            </p>
                        </div>

                    </div>
                </div>



                <section className={styles.tagSection}>
                    <h2 className={`${styles.headingSecondary} ${styles.tagSectionHeading}`}>
                        Amiben segítséget tudok nyújtani
                    </h2>
                    <ul className={styles.tagCardContainer}>
                        <li className={styles.tagCard}>
                            <div className={styles.tagCardImageContainer}>
                                <Image
                                    src="/img/teruletek/onismeret.png"
                                    alt='Önismeret'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Önismeret</span>
                        </li>
                        <li className={styles.tagCard}>
                            <div className={styles.tagCardImageContainer}>
                                <Image
                                    src="/img/teruletek/onertekeles-onelfogadas.png"
                                    alt='Önértékelés és önelfogadás'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Önértékelés, önelfogadás</span>
                        </li>
                        <li className={styles.tagCard}>
                            <div className={styles.tagCardImageContainer}>
                                <Image
                                    src="/img/teruletek/szorongas.png"
                                    alt='Szorongás'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Szorongás</span>
                        </li>
                        <li className={styles.tagCard}>
                            <div className={styles.tagCardImageContainer}>
                                <Image
                                    src="/img/teruletek/utkereses.png"
                                    alt='Útkeresés'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Útkeresés</span>
                        </li>
                        <li className={styles.tagCard}>
                            <div className={styles.tagCardImageContainer}>
                                <Image
                                    src="/img/teruletek/kapcsolati-problemak.png"
                                    alt='Kapcsolati problémák'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Kapcsolati problémák</span>
                        </li>
                        <li className={styles.tagCard}>
                            <div className={styles.tagCardImageContainer}>
                                <Image
                                    src="/img/teruletek/eletvezetesi-kerdesek.png"
                                    alt='Életvezetési kérdések'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Életvezetési kérdések</span>
                        </li>
                        <li className={styles.tagCard}>
                            <div className={styles.tagCardImageContainer}>
                                <Image
                                    src="/img/teruletek/konfliktuskezeles.png"
                                    alt='Konfliktuskezelés'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Konfliktuskezelés</span>
                        </li>
                        <li className={styles.tagCard}>
                            <div className={styles.tagCardImageContainer}>
                                <Image
                                    src="/img/teruletek/onervenyesites-kommunikacios-nehezsegek.png"
                                    alt='Önérvényesítés, kommunikációs nehézségek'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Önérvényesítés, kommunikációs nehézségek</span>
                        </li>
                        <li className={styles.tagCard}>
                            <div className={styles.tagCardImageContainer}>
                                <Image
                                    src="/img/teruletek/stresszkezeles.png"
                                    alt='Stresszkezelés'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Stresszkezelés</span>
                        </li>
                        <li className={styles.tagCard}>
                            <div className={styles.tagCardImageContainer}>
                                <Image
                                    src="/img/teruletek/lelki-rugalmassag-es-ellenallo-kepesseg.png"
                                    alt='Lelki rugalmasság és ellenállóképesség fejlesztése'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Lelki rugalmasság és ellenállóképesség fejlesztése</span>
                        </li>
                        <li className={styles.tagCard}>
                            <div className={styles.tagCardImageContainer}>
                                <Image
                                    src="/img/teruletek/teljesitmenyproblemak.png"
                                    alt='Teljesítményproblémák'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Teljesítményproblémák</span>
                        </li>
                        <li className={styles.tagCard}>
                            <div className={styles.tagCardImageContainer}>
                                <Image
                                    src="/img/teruletek/dontesi-nehezsegek-elakadasok.png"
                                    alt='Döntési nehézségek, elakadások'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Döntési nehézségek, elakadások</span>
                        </li>
                        <li className={`${styles.tagCard} ${styles.tagCardLastRow1}`}>
                            <div className={styles.tagCardImageContainer} >
                                <Image
                                    src="/img/teruletek/erzelemszabalyozas-erzelemkifejezes.png"
                                    alt='Érzelemszabályozás, érzelemkifejezés'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Érzelemszabályozás, érzelemkifejezés</span>
                        </li>
                        <li className={`${styles.tagCard} ${styles.tagCardLastRow2}`}>
                            <div className={styles.tagCardImageContainer}>
                                <Image
                                    src="/img/teruletek/tudatos-jelenlet.png"
                                    alt='Tudatos jelenlét'
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <span className={styles.tagCardText}>Tudatos jelenlét</span>
                        </li>
                    </ul>
                </section>

                <div className={styles.infoContainer}>
                    <div className={styles.infoBlock}>
                        <h2 className={styles.headingTertiary}>
                            Módszerek
                        </h2>

                        <ul className={` mt-6 ${styles.timeline}`}>
                            <li> Személyközpontú szemlélet</li>
                            <li> Aktív-analitikus szemlélet</li>
                            <li> Trauma-informált szemlélet</li>
                            <li> Kognitív viselkedésterápia</li>
                            <li> Csoportterápiás módszerek</li>
                            <li> Rendszerszemléletű gondolkodás</li>
                            <li> Brainspotting</li>
                            <li> OH kártyák</li>
                            <li> Irodalomterápia</li>
                            <li> Pszichoedukáció</li>
                        </ul>

                    </div>

                    <div className={styles.infoBlock}>
                        <h2 className={styles.headingTertiary}>
                            Képzések
                        </h2>

                        <ul className={` mt-6 ${styles.timeline}`}>
                            <li>
                                2026 - jelenleg | AKtív Analitikus Pszichoterapeuták Egyesülete,
                                Aktív-analítikus konzulens
                            </li>
                            <li>
                                2025 | AKtív Analitikus Pszichoterapeuták Egyesülete,
                                Aktív-analízis terápiaelmélet és technika
                            </li>
                            <li>
                                2024 - 2026 |  Eötvös Lóránd Tudományegyetem,
                                Tanácsadó szakpszichológus
                            </li>
                            <li>
                                2021 - 2024 | Kognitív és Sématerápiás Központ,
                                Kognitív viselkedésterápiás konzultáns
                            </li>
                            <li>
                                2020 | OH instruktor
                            </li>
                            <li>
                                2019 - 2021 | Pécsi Tudományegyetem,
                                Irodalomterapeuta
                            </li>
                            <li>
                                2019 | Semmelweis Egyetem, Klinikai Pszichológia Tanszék
                                Problémamegoldó tréning képzés
                            </li>
                            <li>
                                2016 - 2018 | Károli Gáspár Református Egyetem, pszichológia MA
                                Klinikai- és Egészségpszichológiai szakirány
                            </li>
                            <li>
                                2013 - 2016 | Károli Gáspár Református Egyetem, pszichológia BA
                            </li>
                        </ul>
                    </div>
                    <div className={styles.infoBlock}>
                        <h2 className={styles.headingTertiary}>
                            Önismeret
                        </h2>
                        <ul className={` mt-6 ${styles.timeline}`}>
                            <li>
                                Egyéni terápia
                            </li>
                            <li>
                                150 óra sématerápiás önismeret
                            </li>
                            <li>
                                Autogén tréning önismeret
                            </li>
                            <li>
                                480 óra önismereti pályaszocializáció
                            </li>
                        </ul>
                    </div>
                    <div className={styles.infoBlock}>
                        <h2 className={styles.headingTertiary}>
                            Szakmai tapasztalat
                        </h2>
                        <ul className={` mt-6 ${styles.timeline}`}>
                            <li>
                                2026 - jelenleg  | Zenit Pszichoterápiás Központ, Négyszemközt Pszichológiai Műhely
                            </li>
                            <li>
                               2025  | Budai Tanácsadó, pszichológus
                            </li>
                            <li>
                                2022 – 2025 | Soulution Tanácsadó Központ, pszichológus
                            </li>
                            <li>
                                2020-2022 | Mindset Pszichológia, pszichológus
                            </li>
                            <li>
                                2018-2020 | Büntetés-végrehajtás, intézeti pszichológus
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={styles.additionalInfo}>
                    <p>Munkám során egyéni pszichológiai konzultációt tartok, amely nem minősül egészségügyi, pszichoterápiás tevékenységnek. </p>
                    <p>Amennyiben valakinél felmerül, hogy erre lenne szüksége, segítek megtalálni számára a megfelelő szakembert, intézményt.</p>
                </div>

            </div>
        </>
    )
}